import { render } from "./CaptionGray.vue?vue&type=template&id=54b80164&scoped=true"
import script from "./CaptionGray.vue?vue&type=script&lang=js"
export * from "./CaptionGray.vue?vue&type=script&lang=js"

import "./CaptionGray.vue?vue&type=style&index=0&id=54b80164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b80164"]])

export default __exports__